import React, {useEffect, useState} from 'react';

import VIDABOO_CONSTANTS from '../../../config/consts';

import './autoTextTyperComponent.css';

const AutoTextTyperComponent = ({
  isAnimationDisable = false,
  text,
  speed = 15,
  showCursor = false,
  type = VIDABOO_CONSTANTS.AUTO_TEXT_TYPER_COMPONENT_TYPES.WORD,
  getTextMessage = () => {},
  onTypingComplete = () => {},
}) => {
  const [displayedText, setDisplayedText] = useState('');
  const [isCursorVisible, setIsCursorVisible] = useState(false);

  useEffect(() => {
    let intervalId;
    if (isAnimationDisable) {
      setDisplayedText(getTextMessage(text ?? ''));
      onTypingComplete();
    } else {
      setDisplayedText('');
      if (text) {
        if (
          type === VIDABOO_CONSTANTS.AUTO_TEXT_TYPER_COMPONENT_TYPES.CHARACTER
        ) {
          let charIdx = 0;
          intervalId = setInterval(() => {
            setDisplayedText((prev) => prev + text[charIdx]);
            charIdx++;
            if (charIdx === text.length) {
              clearInterval(intervalId);
              onTypingComplete();
            }
          }, speed);
        } else if (
          type === VIDABOO_CONSTANTS.AUTO_TEXT_TYPER_COMPONENT_TYPES.WORD
        ) {
          const words = text.split(' ');
          let wordIndex = 0;
          intervalId = setInterval(() => {
            setDisplayedText((prev) => {
              const space = prev.length > 0 ? ' ' : '';
              return prev + space + words[wordIndex];
            });
            wordIndex++;
            if (wordIndex === words.length) {
              setDisplayedText(getTextMessage(text ?? ''));
              clearInterval(intervalId);
              onTypingComplete();
            }
          }, speed * 5);
        }
      }
    }
    return () => clearInterval(intervalId);
  }, [text, speed, isAnimationDisable]);

  useEffect(() => {
    if (showCursor) {
      const cursorInterval = setInterval(() => {
        setIsCursorVisible((prev) => !prev);
      }, 500);
      return () => {
        clearInterval(cursorInterval);
      };
    }
  }, []);

  return (
    <div className="et-auto-text-typer-container">
      {displayedText}
      {isCursorVisible && <div className="et-attc-cursor">|</div>}
    </div>
  );
};

export default AutoTextTyperComponent;
